import random from 'lodash/random';
import pick from 'lodash/pick';
import noop from 'lodash/noop';
import { useEffect, useMemo, useState } from 'react';

const getIntersectData = (el) => el.dataset.intersectdata;

export const useIntersectionObserver = (pattern = '') => {
  const [intersectRatios, setIntersectRatios] = useState({});
  const [refresh, setRefresh] = useState('');

  useEffect(() => {
    if (pattern === '') return noop;

    const allTrackingElements = document.querySelectorAll(`[data-intersectkey^="${pattern}"]`);
    if (allTrackingElements.length === 0) {
      setTimeout(() => setRefresh(random(0, 1, true)), 200);
      return noop;
    }

    const observers = [];
    const observerCallback = ([entry]) => {
      setIntersectRatios((p) => {
        const latestKeys = Array.from(allTrackingElements).map(getIntersectData);
        const prevState = pick(p, latestKeys);
        return { ...prevState, [entry.target.dataset.intersectdata]: entry.intersectionRatio };
      });
    };

    allTrackingElements.forEach((element) => {
      const observer = new IntersectionObserver(observerCallback, { threshold: Array.from({ length: 50 }, (_, i) => i / 50) });

      observer.observe(element);
      observers.push(observer);
    });

    return () => {
      allTrackingElements.forEach((element, i) => {
        observers[i].unobserve(element);
      });
    };
  }, [pattern, refresh]);

  const maxIntersectRatio = useMemo(() => {
    const ratios = Object.keys(intersectRatios);
    const defaultValue = { key: '', value: 0 };
    if (ratios.length === 0) return defaultValue;

    const max = ratios.reduce((acc, key) => {
      if (!acc || intersectRatios[key] > acc.value) return { key, value: intersectRatios[key] };
      return acc;
    }, defaultValue);
    return max;
  }, [intersectRatios]);

  return maxIntersectRatio;
};
